import { render, staticRenderFns } from "./doctor_recommendation.vue?vue&type=template&id=1f39cf40&scoped=true&"
import script from "./doctor_recommendation.vue?vue&type=script&lang=js&"
export * from "./doctor_recommendation.vue?vue&type=script&lang=js&"
import style0 from "./doctor_recommendation.vue?vue&type=style&index=0&id=1f39cf40&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f39cf40",
  null
  
)

export default component.exports